//#region src/polyfills/index.ts
Promise.withResolvers === void 0 && (Promise.withResolvers = () => {
	let e, t, n = new Promise((n, r) => {
		e = n, t = r;
	});
	return {
		resolve: e,
		reject: t,
		promise: n
	};
});
//#endregion
//#region src/browser/index.ts
function e(e) {
	let t = document.cookie.match(`\\b${e}=([^;]*)\\b`);
	return t ? t[1] : void 0;
}
function t() {
	let e = "testData";
	try {
		let { localStorage: t } = window;
		t.setItem(e, e), t.getItem(e), t.removeItem(e);
	} catch {
		return !1;
	}
	return !0;
}
//#endregion
//#region src/config/index.ts
function n(e) {
	return Array.isArray(e) && e.length > 0 && e.every((e) => typeof e == "string" && e.trim().length > 0);
}
function r(e) {
	return typeof structuredClone == "function" ? structuredClone(e) : JSON.parse(JSON.stringify(e));
}
function i(e) {
	return Object.freeze(e), Array.isArray(e) ? e.forEach((e) => {
		typeof e == "object" && e && !Object.isFrozen(e) && i(e);
	}) : Object.values(e).forEach((e) => {
		typeof e == "object" && e && !Object.isFrozen(e) && i(e);
	}), e;
}
var a = (() => {
	let e = window.__streamlit;
	if (e) return i(r(e));
})();
function o() {
	return a;
}
var s = {
	get BACKEND_BASE_URL() {
		return a?.BACKEND_BASE_URL;
	},
	get HOST_CONFIG_BASE_URL() {
		return a?.HOST_CONFIG_BASE_URL;
	},
	get DOWNLOAD_ASSETS_BASE_URL() {
		return a?.DOWNLOAD_ASSETS_BASE_URL;
	},
	get MAIN_PAGE_BASE_URL() {
		return a?.MAIN_PAGE_BASE_URL;
	},
	get CUSTOM_COMPONENT_CLIENT_ID() {
		return a?.CUSTOM_COMPONENT_CLIENT_ID;
	},
	get LIGHT_THEME() {
		return a?.LIGHT_THEME;
	},
	get DARK_THEME() {
		return a?.DARK_THEME;
	},
	get ENABLE_RELOAD_BASED_ON_HARDCODED_STREAMLIT_VERSION() {
		return a?.ENABLE_RELOAD_BASED_ON_HARDCODED_STREAMLIT_VERSION;
	},
	get HOST_CONFIG() {
		return a?.HOST_CONFIG;
	}
};
//#endregion
//#region src/types/index.ts
function c(e) {
	return e != null;
}
function l(e) {
	return e == null;
}
//#endregion
//#region src/uri/index.ts
var u = /\/+$/, d = /^\/+/;
function f({ hostname: e, port: t, pathname: n, protocol: r }, i) {
	let a = p(n, i);
	return `${r}//${e}${t ? `:${t}` : ""}/${a}`;
}
function p(e, t) {
	return e = e.replace(u, "").replace(d, ""), t = t.replace(u, "").replace(d, ""), e.length === 0 ? t : `${e}/${t}`;
}
var m = () => window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
//#endregion
export { s as StreamlitConfig, f as buildHttpUri, e as getCookie, o as getStreamlitConfig, m as isLocalhost, l as isNullOrUndefined, n as isValidAllowedOrigins, t as localStorageAvailable, p as makePath, c as notNullOrUndefined };
